// Typelizer digest 6431e046e94315d559833b23b0229dcd
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /ses_tracker/image/:message_uuid.png */
  image: (
    params: { messageUuid: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/ses_tracker/image/:message_uuid.png', params, options),
    method: 'get',
  }),

  /** POST /ses_tracker/sns */
  sns: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/ses_tracker/sns', {}, options),
    method: 'post',
  }),
}
